// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { Roboto } from "@mcmc/XDL/Utilities/sharedStyles";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


const mapDispatchToProps = {
    cancelPunchOut
};

interface OwnProps extends WidgetProps {}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

interface HeaderCancelPunchOutStyles {
    container: LinkPresentationProps;
}

export const headerCancelPunchOutStyles: HeaderCancelPunchOutStyles = {
    container: {
        color: "navigation.secondary.text.main",
        hoverStyle: {
            color: "navigation.secondary.text.hover",
        },
        typographyProps: {
            ...Roboto,
            weight: 400,
            css: css`
                letter-spacing: 0;
            `,
        },
    },
    
};

const styles = headerCancelPunchOutStyles;

const HeaderCancelPunchOut = ({cancelPunchOut}: Props) => {
    return (
        <Link {...styles.container} onClick={cancelPunchOut}>
          {translate("Exit Punchout")}
        </Link>
    );
};

const headerCancelPunchOut: WidgetModule = {
    component: connect(null, mapDispatchToProps)(HeaderCancelPunchOut),
    definition: {
        group: "Common",
    },
};

export default headerCancelPunchOut;
